import { render, staticRenderFns } from "./TablesFilters.vue?vue&type=template&id=33064838&"
import script from "./TablesFilters.vue?vue&type=script&lang=js&"
export * from "./TablesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports